/**
 * Safely parse a URL search parameter value with error recovery.
 * On parse failure, removes the invalid parameter from the URL and returns an empty array.
 */
export const parseUrlParam = <T>(func: () => T, key: string): T => {
  try {
    return func();
  } catch (e) {
    console.error(e);
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    history.replaceState({}, '', url);
    return [] as T;
  }
};
